<template>
    <div class="content-card-wrapper">
        <div class="content-card-image" v-if="!textOnly">
            <slot name="image"></slot>
        </div>
        <div class="content-card-title" v-if="!textOnly">
            <slot name="title"></slot>
        </div>
        <div class="content-card-text">
            <slot></slot>
        </div>
        <div class="content-card-link" v-if="!textOnly">
            <slot name="link"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        textOnly: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
};
</script>
